import Countries from "assets/countries.json"

export default code => {
    if(code && Countries.filter(country => country.alpha3 === code) && Countries.filter(country => country.alpha3 === code).length){
        return Countries.filter(country => country.alpha3 === code)[0].name
    }

    return code
}